// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  organizationId: __t.string().primaryKey().name("organization_id"),
  publishedUpdatedAt: __t.timestamp().name("published_updated_at"),
  publishedAt: __t.timestamp().name("published_at"),
  status: __t.string(),
  error: __t.option(__t.string()),
});
